/*
  Tokyo Romance Club — fixes the standalone /cart page becoming unable to
  scroll on Desktop.

  Root cause: on Desktop (>=990px) the theme's own scroll container is
  `.page-wrapper`, not <html> (see assets/base.css:
  `html:has(.page-wrapper){height:100dvh;overflow:hidden}` +
  `.page-wrapper{height:100dvh;overflow-y:auto}`). Opening any drawer/dialog
  (e.g. the Cart Drawer after Add to Cart) sets `scroll-lock` on <html> via
  assets/utilities.js's reference-counted lock, and snippets/theme-drawer.liquid
  saves which drawers were open to sessionStorage so they can restore across
  a full navigation.

  That restore script's own comment acknowledges a gap: "saved drawer IDs
  may not exist on every page (e.g. cart-drawer on /cart)" — the Cart
  Drawer is intentionally NOT rendered on the /cart page itself. So if a
  shopper had the Cart Drawer open and then navigated to /cart from inside
  it (e.g. "View cart"), the restore loop can't find a matching drawer
  element to restore/close, and the `scroll-lock` attribute + the
  `.page-wrapper--drawer-open` class from the previous page state are never
  cleared — leaving the whole /cart page unscrollable.

  This does not touch the drawer/dialog system itself (theme-drawer.js,
  dialog.js, cart-drawer.js, utilities.js are all untouched, and the Cart
  Drawer keeps working normally everywhere else) — it only clears the
  leftover attribute/class specifically when landing on the /cart page and
  nothing is actually open, which is exactly the gap the native code's own
  comment describes.
*/
(function () {
  if (window.__trcCartScrollFixInit) return;
  window.__trcCartScrollFixInit = true;

  if (document.documentElement.classList.contains('shopify-design-mode')) return;

  function fix() {
    if (!document.querySelector('.cart-page')) return;
    // Something is genuinely open (a real dialog or an open <details> that
    // owns scroll-lock) — leave it alone, this isn't the stale-state case.
    if (document.querySelector('dialog[open], details[scroll-lock][open]')) return;

    if (document.documentElement.hasAttribute('scroll-lock')) {
      document.documentElement.removeAttribute('scroll-lock');
    }
    document.querySelector('.page-wrapper')?.classList.remove('page-wrapper--drawer-open');
  }

  if (document.readyState !== 'loading') {
    fix();
  } else {
    document.addEventListener('DOMContentLoaded', fix);
  }

  // The restore script in snippets/theme-drawer.liquid runs on `pageshow`
  // (fires for both fresh loads and bfcache/view-transition navigations,
  // after this script's own DOMContentLoaded/immediate check already ran).
  // Re-check after it so a leftover lock it couldn't resolve is still caught.
  window.addEventListener('pageshow', fix);
})();
